export var Variants;
(function (Variants) {
    Variants["primary"] = "primary";
    Variants["secondary"] = "secondary";
})(Variants || (Variants = {}));
export var Types;
(function (Types) {
    Types["tag"] = "tag";
    Types["badge"] = "badge";
})(Types || (Types = {}));
//# sourceMappingURL=constants.js.map